module.exports = __webpack_public_path__ + "static/media/aprove.4810e87e.svg";